export default __webpack_public_path__ + "static/media/bubble3.c31d5253.png";